import { render, staticRenderFns } from "./EmbeddablePlayer.vue?vue&type=template&id=3c8eb4d4&"
import script from "./EmbeddablePlayer.vue?vue&type=script&lang=js&"
export * from "./EmbeddablePlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports